import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/shutterstock_2129309294-min.jpg")